{
  "fieldMapping": {
    "fieldType": {
      "label": "Field Type"
    },
    "typeOverridden": "(overridden)",
    "advanced": {
      "label": "Advanced"
    },
    "dataMasking": {
      "label": "Data Masking",
      "noRules": "No mask rules added yet.",
      "addRule": "Add mask rule",
      "optionColumn": "Option",
      "pdfExportOnValueColumn": "PDF export ON value",
      "maskValueColumn": "Mask value",
      "exactValuePlaceholder": "Exact value",
      "maskValuePlaceholder": "Enter mask value",
      "resetMask": "Reset mask to PDF on value"
    },
    "formatter": {
      "label": "Formatter"
    },
    "defaultValue": {
      "label": "Default Value",
      "placeholder": "Fallback if empty"
    },
    "errorWhenEmpty": {
      "label": "Error when empty"
    }
  },
  "fieldList": {
    "addField": {
      "label": "Add Field",
      "placeholder": "Field name",
      "typeLabel": "Type",
      "addButton": "Add"
    },
    "search": {
      "placeholder": "Search fields..."
    },
    "filters": {
      "all": "all",
      "mapped": "mapped",
      "unmapped": "unmapped"
    },
    "actions": {
      "rename": "Rename field",
      "clone": "Clone field",
      "delete": "Delete field"
    },
    "deleteDialog": {
      "title": "Delete Field",
      "body": "Are you sure you want to delete field \"{{fieldName}}\"?"
    },
    "validation": {
      "fieldNameRequired": "Field name is required",
      "invalidFieldName": "Invalid field name"
    },
    "empty": "No fields found",
    "accordion": {
      "summary": "Fields ({{mappedCount}}/{{totalCount}} mapped)"
    },
    "typeOverride": {
      "chip": "→ {{type}}"
    }
  },
  "batchUpload": {
    "title": "Batch Upload Fields",
    "button": "Batch Upload",
    "uploadStep": "Upload a CSV file",
    "selectFieldNameColumn": "Select the column containing field names",
    "selectFieldTypeColumn": "Field type column (optional)",
    "mappingHelpText": "Map each column to a target before continuing. Only one column can map to Field Name, and at most one can map to Field Type.",
    "previewRowsHint": "Showing first {{count}} rows of {{total}} total rows",
    "none": "None",
    "fileLoaded": "Loaded {{fileName}}",
    "stepLabel": "Step {{current}} of {{total}}",
    "emptyNameValue": "(empty)",
    "nextButton": "Next",
    "backButton": "Back",
    "cancelButton": "Cancel",
    "importButton": "Import Fields",
    "status": {
      "willAdd": "Will add",
      "duplicateExisting": "Duplicate (skip)",
      "duplicateCsv": "Duplicate in CSV (skip)",
      "emptyName": "Empty name (skip)",
      "unknownType": "Unknown type \"{{rawType}}\" (defaulted to TextField)"
    },
    "preview": {
      "title": "Preview",
      "fieldsToAdd": "{{count}} fields will be added",
      "duplicatesSkipped": "{{count}} duplicates will be skipped",
      "unknownTypeDefaulted": "{{count}} with unknown type defaulted to TextField",
      "columns": {
        "fieldName": "Field Name",
        "fieldType": "Field Type",
        "status": "Status"
      }
    },
    "errors": {
      "parseFailed": "Failed to parse CSV file"
    },
    "mappingOptions": {
      "ignore": "Ignore",
      "fieldName": "Field Name",
      "fieldType": "Field Type"
    }
  },
  "settings": {
    "moreSettings": "More settings",
    "title": "Form map settings",
    "esignSection": "E-sign",
    "pdfSection": "PDF output",
    "signaturePageNumberBase": {
      "label": "Signature page number base",
      "help": "Use ONE for DocuSign, ZERO for OneSpan",
      "one": "ONE (1-based)",
      "zero": "ZERO (0-based)"
    },
    "removePdfMaxLength": {
      "label": "Remove PDF max length"
    }
  },
  "testPanel": {
    "eSignProvider": {
      "label": "E-Sign Provider",
      "helpText": "Coordinate system used for signature field locations",
      "options": {
        "rawPdf": "Raw PDF (bottom-left, 72 DPI)",
        "docusign": "DocuSign (top-left, 72 DPI)",
        "onespan": "OneSpan (top-left, 93.6 DPI)"
      }
    },
    "signatureFieldLocations": {
      "title": "Signature Field Locations"
    }
  }
}
